const JsIE10 = {
	init () {

		/*
		* IE 10 Compatibility & Removing style attribute from nav
		*/

		var bIE10 = document.documentElement;
		bIE10.setAttribute('data-useragent',  navigator.userAgent);
		bIE10.setAttribute('data-platform', navigator.platform );
		if(navigator.userAgent.match(/MSIE 10/)){
			// $(".c-nav").css("left", "");
			$(".c-nav").removeAttr("style","left");
			$( '.c-nav' ).removeClass( 'l-nav' );
		} else {
		}

	}
};

export default JsIE10;


// WEBPACK FOOTER //
// ./src/js/aras-kids-modules/IE10-compat.js